export default __webpack_public_path__ + "static/media/NoteImageMobile.9de73597.png";